import { FlexRow } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FC } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import { ViewAccordionForNonPublic, ViewCategory } from "./CustomViewDialogLeftPanelAccordion";

export const CustomViewDialogPersonalViews: FC<{}> = observer(() => {
	const {
		customViewStore: {
			currentSelectedUser,
			filteredPersonalItem,
			showPersonalViewSection,
			showUserSelector,
			switchUser,
			userList,
		},
	} = useCustomViewDialogStore();

	return (
		<>
			{showPersonalViewSection && (
				<FlexRow 
					data-csi-automation="CustomViewDialogPersonalViews"
					data-csi-custom-view-party-id={filteredPersonalItem?.url}
				>
					<ViewAccordionForNonPublic
						category={ViewCategory.PERSONAL}
						currentSelectedUserItem={currentSelectedUser}
						isPersonal
						nonGlobalCustomViewItem={filteredPersonalItem}
						onSwitchUser={switchUser}
						showUserSelector={showUserSelector}
						userList={userList}
					/>
				</FlexRow>
			)}
		</>
	);
});

export default CustomViewDialogPersonalViews;